// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3CLfy","topBottomGutter":"Layout_topBottomGutter__3appA"};